import {Centrifuge} from './centrifuge.js';
export default Centrifuge;



// WEBPACK FOOTER //
// ./src/index.js